export const singleSPA = {
    historyPush: (to: string, state?: unknown): void => {
        window.history.pushState(state, '', to)
    },
}
